import React from 'react';

const AIServices = () => {
  return (
    <div className="page-content">
      <section className="hero-small">
        <div className="container">
          <h1>AI & Machine Learning</h1>
          <p>Transform your business with intelligent automation and cognitive computing solutions.</p>
        </div>
      </section>
      
      <section className="services-detail">
        <div className="container">
          <div className="service-grid">
            <div className="service-card">
              <h3>Machine Learning Models</h3>
              <p>Custom ML models for predictive analytics and automation</p>
            </div>
            <div className="service-card">
              <h3>Natural Language Processing</h3>
              <p>Advanced text analysis and conversational AI solutions</p>
            </div>
            <div className="service-card">
              <h3>Computer Vision</h3>
              <p>Image recognition and visual intelligence systems</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIServices;